import type { Pagination } from '@/services/types/api.types';

export function isSingleElementOnLastPage(pagination: Pagination) {
  if (pagination.page === 1) return false;
  const totalPages = Math.ceil(pagination.rowsNumber / pagination.rowsPerPage);
  const isLastPage = pagination.page === totalPages;
  const isLastRow = pagination.rowsNumber % pagination.rowsPerPage === 1;
  return isLastPage && isLastRow;
}

/** The page to show once a row is deleted: the one before, when the row was alone on the last page. */
export function pageAfterDeletion(pagination: Pagination) {
  return isSingleElementOnLastPage(pagination) ? pagination.page - 1 : pagination.page;
}
